export default {
  showPageHistoryNav: false,
  showSearchPanel: false,
  isFullScreen: false,
  isPreferencesView: false,
  characterLimitLine: 2,
  isMobile: false,
  isPublicViewMode: false,
  isLoadingImages: false
};
